<template>
    <div class="setup-box">
        <div class="shehzi-div">
            <div class="frame-take">
                <div class="left-up">
                    <p>{{$t('SetUp.text_tilte1')}}</p>
                    <p>{{$t('SetUp.text_p_Subtitle')}}</p>
                </div>
                <div class="right-up">
                    <p class="R-fu-tilte">{{$t('SetUp.R_tilte_ys')}}</p>
                    <p class="R-jieshao">
                        {{$t('SetUp.R_Subtitle_ys')}}
                        <span v-show="this.$i18n.locale == 'zh'">
                            {{this.$store.state.ashen == 'false' ?'暗色':'亮色'}}
                        </span>
                        <span v-show="this.$i18n.locale == 'en'">
                            {{this.$store.state.ashen == 'false' ?'dark':'bright'}}
                        </span>
                    </p>
                    <div class="Fang-kuai">
                        <div class="beise iconfont icon-taiyang" @click="Liangse()"></div>
                        <div class="beise iconfont icon-yueliang" @click="Aanse()"></div>
                    </div>
                    <p class="R-fu-tilte">{{$t('SetUp.R_songci_ys')}}</p>
                    <p class="R-jieshao">{{$t('SetUp.R_songci_sub_ys')}}</p>
                    <div class="Fang-kuai">
                        <div class="beise iconfont icon-taiyang"></div>
                    </div>
                    <p class="R-fu-tilte">{{$t('SetUp.language')}}</p>
                    <el-select class="xialaxuanze" v-model="region" placeholder="" @change="changeSelect">
                        <el-option v-for="(item,index) in options" :key="index" 
                        :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="frame-take">
                <div class="left-up">
                    <p>{{$t('SetUp.two_tilte')}}</p>
                </div>
                <div class="right-up">
                    <p class="R-fu-tilte">{{ $t('SetUp.donghua') }}</p>
                    <p class="R-jieshao">{{ $t('SetUp.NOdonghua') }}</p>
                </div>
            </div>
            <div class="frame-take">
                <div class="left-up">
                    <p>{{$t("SetUp.three_tilte")}}</p>
                </div>
                <div class="right-up">
                    <p class="R-fu-tilte">{{$t("SetUp.bofanglist")}}</p>
                    <el-radio class="R-jieshao" style="margin-top: 15px;" v-model="radio" label="1">{{$t("SetUp.bofang_text")}}</el-radio>
                    
                </div>
            </div>
            <div class="frame-take">
                <div class="left-up">
                    <p>{{$t("SetUp.four_tilte")}}</p>
                </div>
                <div class="kuaijiejian">
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_bofang")}}</p>
                        <div class="jian_kuang">
                             <div class="l-jian-key">Ctrl</div>
                             <div class="l-jian-key">Space</div>
                        </div>
                    </div>
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_shang")}}</p>
                        <div class="jian_kuang">
                            <div class="l-jian-key">Ctrl</div>
                            <div class="l-jian-key">←</div>
                        </div>
                    </div>
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_xia")}}</p>
                        <div class="jian_kuang">
                            <div class="l-jian-key">Ctrl</div>
                            <div class="l-jian-key">→</div>
                        </div>
                    </div>
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_yinliang_top")}}</p>
                        <div class="jian_kuang">
                            <div class="l-jian-key">Ctrl</div>
                            <div class="l-jian-key">↑</div>
                        </div>
                    </div>
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_yinliang_bou")}}</p>
                        <div class="jian_kuang">
                            <div class="l-jian-key">Ctrl</div>
                            <div class="l-jian-key">↓</div>
                        </div>
                    </div>
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_sousuo")}}</p>
                        <div class="jian_kuang">
                            <div class="l-jian-key">Ctrl</div>
                            <div class="l-jian-key">Q</div>
                        </div>
                    </div>
                    <div class="key_kuai">
                        <p class="l-text-key">{{$t("SetUp.key_songci")}}</p>
                        <div class="jian_kuang">
                            <div class="l-jian-key">Esc</div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="di-synopsis">MyEreeMP3:&nbsp;1.0.1</p>
            <p class="di-synopsis">vue:&nbsp;2.0.0</p>
        </div>  
    </div>
</template>
<script>

    export default{
        data(){
            return{
                region:localStorage.getItem('lang')=='zh'?'简体中文':localStorage.getItem('lang')=='en'?'English':'简体中文' ,
                options: [
                    { label: '简体中文', value: 'zh' },
                    { label: 'English', value: 'en' }
                ],
                radio:'1'
            }
        },
        methods:{
            //白主题切换
            Liangse(){
                this.$store.state.ashen = 'true';
                    this.$message({
                        message: '已设置主题为亮色',
                        type: 'success',
                        duration:'1000'
                    });
                localStorage.setItem('theme','true');
            },
            Aanse(){
                this.$store.state.ashen = 'false';
                    this.$message({
                        message: '已设置主题为暗色',
                        type: 'success',
                        duration:'1000'
                    });
                localStorage.setItem('theme','false');
            },

            //中英文切换
            changeSelect(e){
                if(e=='zh'){
                    this.$i18n.locale = 'zh';
                    this.region = "简体中文";
                    this.$message({
                        message: '已设置为简体中文',
                        type: 'success',
                        duration:'1000'
                    });
                    localStorage.setItem('lang',e);
                }else{
                    this.$i18n.locale = 'en';
                    this.region = "English";
                    //e-插件弹窗
                    this.$message({
                        message: 'Already set as English',
                        type: 'success',
                        duration:'1000'
                    });
                    localStorage.setItem('lang',e);//存储
                }
            }
        }
    }
</script>
<style lang="scss">
    .setup-box{
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        .shehzi-div{
            width: 1366px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 35px;
            margin-bottom: 35px;
            .frame-take{
                width: 100%;
                padding-bottom: 20px;
                border-bottom: solid 1px var(--setup-border);
                display: flex;
                margin-bottom: 30px;
                .left-up{
                    width: 460px;
                    display: flex;
                    flex-direction: column;
                    p:nth-child(1){
                        font-size: var(--nav-text-fsize16);
                        font-family: YuanTi;
                        // font-weight: 900;
                        color: var(--them-color);
                    }
                    p:nth-child(2){
                        font-size: var(--nav-text-fsize);
                        font-family: YuanTi;
                        // font-weight: 900;
                        color: var(--setup-color-hui);
                        margin-top: 6px;
                    }
                }
                .right-up{
                    width: 600px;
                    display: flex;
                    flex-direction: column;
                    .R-fu-tilte{
                        font-size: var(--nav-songTlite-fsize);
                        // font-weight: bold;
                        font-family: YuanTi;
                        color: var(--them-color);
                    }
                    .R-jieshao{
                        font-size: var(--nav-text-fsize);
                        font-family: YuanTi;
                        font-weight: 900;
                        color: var(--setup-color-hui);
                        margin-top: 6px;
                    }
                    .Fang-kuai{
                        width: 66px;
                        display: flex;
                        align-items: center;
                        border-radius: 3px;
                        margin-top: 17px;
                        overflow: hidden;
                        margin-bottom: 26px;
                        .beise{
                            width: 33px;
                            height: 33px;
                            background-color: var(--sousuo-kuai-background);
                            font-size: var(--nav-text-fsize19);
                            text-align: center;
                            line-height: 33px;
                            cursor: pointer;
                            color: var(--sousuo-icon-color);
                            border-right: solid 1px var(--setup-border);
                        }
                        div:last-child {
                            border-right: none;
                        }
                        .beise:hover{
                            background-color: var(--sousuo-hover);
                        }
                    }
                    .xialaxuanze{
                        width: 50%;
                        height: 40px;
                        margin-top: 10px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }
                    
                }
                .kuaijiejian{
                    width: 300px;
                    display: flex;
                    flex-direction: column;
                    .key_kuai{
                        width: 300px;
                        display: flex;
                        align-items: center;
                        justify-content:space-between;
                        margin-bottom: 13px;
                        .l-text-key{
                            font-size: var(--nav-songTlite-fsize);
                            font-family: YuanTi;
                            // font-weight: bold;
                            color: var(--them-color);
                        }
                        .jian_kuang{
                            display: flex;
                            align-items: center;
                            .l-jian-key{
                                padding: 2px 5px;
                                border: solid 1px var(--setup-border);
                                border-radius: 3px;
                                font-size: var(--nav-text-fsize);
                                color:var(--setup-color-hui);
                                box-shadow: 1px 2px 0 var(--setup-color-hui);
                                cursor: pointer;
                                margin-right: 5px;
                            }
                        }
                        
                    }
                }
            }
            .di-synopsis{
                width: 100%;
                font-size: var(--nav-text-fsize);
                font-family: YuanTi;
                color: var(--them-color);
                margin-bottom: 10px;
            }
        }

    }
    .el-input__inner{
        background-color: var(--sousuo-kuai-background);
        border: none;
        color: var(--them-color);
    }
    .el-input__inner:hover{
        background-color: var(--sousuo-hover);
        
        border: none;
    }
    .el-input__inner:focus{
        background-color: var(--them-background);
        border: solid 1px var(--lan-hover-background);
    }
    .el-radio__label{
        color: var(--setup-color-hui) !important;
    }
</style>